import { useMsal } from "@azure/msal-react";
import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { Col } from "react-bootstrap";
import { useParams, useLocation } from "react-router-dom";
import "react-table/react-table.css";
import { AuthContext } from "../../AuthContext";
import { SEARCHED_PROPS_VIEWALL } from "../../constants/Constant";
import { DATABOOK_API } from "../../constants/serverConfig";
import { protectedResources } from "../../msalConfig";
import { NavBarAndLandingPageContext } from "../../NavBarContextAndLandingPageContext";
import { isObjectEmpty } from "../CommonUtils";
import AdvancedFilterComponent from "../genericComponents/AdvancedFilterComponent";
import Spinner from "../Spinner";
import ReusableDatasetsContent from "./ReusableDatasetsContent";

const DomainTableData = () => {
  const params = useParams();
  const location = useLocation();
  const { searchparam } = params || {};
  const { searchterm } = location.state || {};
  const [data, setData] = useState([]);
  const [filteredata, setFilteredData] = useState([]);
  // const [responseFilterObj, setResponseFilterObj] = useState();
  const [responseCount, setResponseCount] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);
  const [isFetching, setIsFetching] = useState(false);
  const [filters, setSearchFilter] = useState("");
  const [initialresponseFilterFlag, setInitialresponseFilterFlag] =
    useState(true);
  const { roletoggle, searchKeyword, selectedoutputportcontext } = useContext(NavBarAndLandingPageContext);
  const { criteria, term } = searchKeyword;
  let outport = [];
  if (selectedoutputportcontext === "all") {
    outport = [];
  } else {
    outport.push(selectedoutputportcontext)
  }
  const [advancedFilters, setAdvancedFilter] = useState({
    // datasources: [],
    term: term,
    layers: [],
    schemas: [],
    // domain: [],
    orgModels: [],
    businesses: [],
    classifications: [],
    platforms: [],
    products: [],
    certification: false,
    // refreshFrequency: 0,
    sensitivities: [],
    assetTypes: [],
    formats: [],
    outputPorts: []
  });
  const [filterOwnedDataset, setFilterOwnedDataset] = useState(false);
  const [certifiedtoggle, setCertifiedToggle] = useState(false);

  // ------------Fitler State--------------
  const [allSelectedFilter, setAllSelectedFilter] = useState([]);
  const [selecteddatasource, setSelectedDataSources] = useState([]);
  const [selecteddomain, setSelectedDataDomain] = useState([]);
  const [selectedlayers, setSelectedLayers] = useState([]);
  const [selectedschema, setSelectedSchema] = useState([]);
  const [selectedorgmodel, setSelectedOrgModel] = useState([]);
  const [selectedbusinesses, setSelectedBusinesses] = useState([]);
  const [selectedclassifications, setSelectedClassifications] = useState([]);
  const [selectedplatforms, setSelectedPlatforms] = useState([]);
  const [selectedproducts, setSelectedProducts] = useState([]);
  const [selectedrefreshfreq, setSelectedRefreshFreq] = useState(0);
  const [selectedsensitivities, setSelectedSensitivities] = useState([]);
  const [selectedassetTypes, setSelectedassetTypes] = useState([]);
  const [selectedfileFormats, setSelectedfileFormats] = useState([]);
  const [selectedcertification, setSelectedCertification] = useState(false);
  const [ownedataset, setOwneDataset] = useState("");
  const [selectedOutputPorts, setSelectedoutputPorts] = useState([]);



  const [datasource, setDataSources] = useState([]);
  const [layers, setLayers] = useState([]);
  const [schemas, setSchema] = useState([]);
  const [domain, setDomain] = useState([]);
  const [orgmodel, setOrgModel] = useState([]);
  const [businesses, setBusinesses] = useState([]);
  const [classifications, setClassifications] = useState([]);
  const [platforms, setPlatforms] = useState([]);
  const [products, setProducts] = useState([]);
  const [refreshFreq, setRefreshFreq] = useState([]);
  const [sensitivities, setSensitivities] = useState([]);
  const [assetTypes, setAssetTypes] = useState([]);
  const [fileFormats, setFileFormats] = useState([]);
  const [certification, setCertification] = useState([]);
  const [filterloading, setFilterLoading] = useState(false);
  const [previouscategory, setPreviousCategory] = useState("");
  const [outputPorts, setoutputPorts] = useState([]);




  const { getToken, token, error } = useContext(AuthContext);
  const { instance } = useMsal();

  const account = instance.getActiveAccount();
  const request = {
    scopes: protectedResources.databook.scopes,
    account: account,
  };
  const [prevterm, setPreviousTerm] = useState("");



  const handleAddAndRemoveFilter = (action, value, e) => {
    let filterdValues = [...allSelectedFilter];
    let payload = { ...advancedFilters }
    switch (action) {
      case "datasource":
        let datasource = [...selecteddatasource];
        if (e?.target?.checked) {
          datasource.push(value);
          filterdValues.push({ filterType: action, value });
          setAllSelectedFilter(filterdValues);
          setSelectedDataSources(datasource);
        } else {
          let sourceremoved = datasource.filter((e) => e !== value);
          let removeSelectedFilter = filterdValues?.filter(
            (filter) =>
              !(filter.value === value && filter.filterType === action)
          );
          setSelectedDataSources(sourceremoved);
          setAllSelectedFilter(removeSelectedFilter);
        }
        break;
      case "layers":
        let layerselected = [...selectedlayers];
        if (e?.target?.checked) {
          layerselected.push(value);
          filterdValues.push({ filterType: action, value });
          setAllSelectedFilter(filterdValues);
          setSelectedLayers(layerselected);
        } else {
          let layersemoved = layerselected.filter((e) => e !== value);
          let removeSelectedFilter = filterdValues.filter(
            (filter) =>
              !(filter.value === value && filter.filterType === action)
          );
          setSelectedLayers(layersemoved);
          setAllSelectedFilter(removeSelectedFilter);
        }
        break;
      case "schemas":
        let schemasselect = [...selectedschema];
        if (e?.target?.checked) {
          schemasselect.push(value);
          filterdValues.push({ filterType: action, value });
          setAllSelectedFilter(filterdValues);
          setSelectedSchema(schemasselect);
        } else {
          let schemaremoved = schemasselect.filter((e) => e !== value);
          let removeSelectedFilter = filterdValues.filter(
            (filter) =>
              !(filter.value === value && filter.filterType === action)
          );
          setSelectedSchema(schemaremoved);
          setAllSelectedFilter(removeSelectedFilter);
        }
        break;
      case "domain":
        let domainsselect = [...selecteddomain];
        if (e?.target?.checked) {
          filterdValues.push({ filterType: action, value });
          setAllSelectedFilter(filterdValues);
          domainsselect.push(value);
          setSelectedDataDomain(domainsselect);
        } else {
          let domainremoved = domainsselect.filter((e) => e !== value);
          let removeSelectedFilter = filterdValues.filter(
            (filter) =>
              !(filter.value === value && filter.filterType === action)
          );
          setSelectedDataDomain(domainremoved);
          setAllSelectedFilter(removeSelectedFilter);
        }
        break;
      case "orgmodel":
        let orgmodelselect = [...selectedorgmodel];
        if (e?.target?.checked) {
          filterdValues.push({ filterType: action, value });
          setAllSelectedFilter(filterdValues);
          orgmodelselect.push(value);
          setSelectedOrgModel(orgmodelselect);
        } else {
          let orgmodelremoved = orgmodelselect.filter((e) => e !== value);
          let removeSelectedFilter = filterdValues.filter(
            (filter) =>
              !(filter.value === value && filter.filterType === action)
          );
          setSelectedOrgModel(orgmodelremoved);
          setAllSelectedFilter(removeSelectedFilter);
        }
        break;
      case "businesses":
        let businessesselect = [...selectedbusinesses];
        if (e?.target?.checked) {
          filterdValues.push({ filterType: action, value });
          setAllSelectedFilter(filterdValues);
          businessesselect.push(value);
          setSelectedBusinesses(businessesselect);
        } else {
          let businessesremoved = businessesselect.filter((e) => e !== value);
          let removeSelectedFilter = filterdValues.filter(
            (filter) =>
              !(filter.value === value && filter.filterType === action)
          );
          setSelectedBusinesses(businessesremoved);
          setAllSelectedFilter(removeSelectedFilter);
        }
        break;
      case "classifications":
        let classificationsselect = [...selectedclassifications];
        if (e?.target?.checked) {
          let sensitvitylabel = e.currentTarget?.dataset?.classification;
          filterdValues.push({ filterType: action, value, label: sensitvitylabel });
          setAllSelectedFilter(filterdValues);
          classificationsselect.push(value);
          setSelectedClassifications(classificationsselect);
        } else {
          let classificationsremoved = classificationsselect.filter(
            (e) => e !== value
          );
          let removeSelectedFilter = filterdValues.filter(
            (filter) =>
              !(filter.value === value && filter.filterType === action)
          );
          setSelectedClassifications(classificationsremoved);
          setAllSelectedFilter(removeSelectedFilter);
        }
        break;
      case "platforms":
        let platformsselect = [...selectedplatforms];
        if (e?.target?.checked) {
          filterdValues.push({ filterType: action, value });
          setAllSelectedFilter(filterdValues);
          platformsselect.push(value);
          setSelectedPlatforms(platformsselect);
        } else {
          let platformsremoved = platformsselect.filter((e) => e !== value);
          let removeSelectedFilter = filterdValues.filter(
            (filter) =>
              !(filter.value === value && filter.filterType === action)
          );
          setSelectedPlatforms(platformsremoved);
          setAllSelectedFilter(removeSelectedFilter);
        }
        break;
      case "products":
        let productsselect = [...selectedproducts];
        if (e?.target?.checked) {
          filterdValues.push({ filterType: action, value });
          setAllSelectedFilter(filterdValues);
          productsselect.push(value);
          setSelectedProducts(productsselect);
        } else {
          let productsremoved = productsselect.filter((e) => e !== value);
          let removeSelectedFilter = filterdValues.filter(
            (filter) =>
              !(filter.value === value && filter.filterType === action)
          );
          setSelectedProducts(productsremoved);
          setAllSelectedFilter(removeSelectedFilter);
        }
        break;
      case "refreshFrequencies":
        // let refreshfreqselect = [...selectedrefreshfreq];
        // if (e?.target?.checked) {
        //   filterdValues.push({ filterType: action, value });
        //   setAllSelectedFilter(filterdValues);
        //   refreshfreqselect.push(value);
        //   setSelectedRefreshFreq(refreshfreqselect);
        // } else {
        //   let refreshfreqremoved = refreshfreqselect.filter((e) => e !== value);
        //   let removeSelectedFilter = filterdValues.filter(
        //     (filter) => !(filter.value === value && filter.filterType === action)
        //   );
        //   setSelectedRefreshFreq(refreshfreqremoved);
        //   setAllSelectedFilter(removeSelectedFilter);
        // }
        setSelectedRefreshFreq(value);
        break;
      case "sensitivities":
        let sensitivitiesselect = [...selectedsensitivities];
        if (e?.target?.checked) {
          let sensitvitylabel = e.currentTarget?.dataset?.sensitivity;
          filterdValues.push({ filterType: action, value, label: sensitvitylabel });
          setAllSelectedFilter(filterdValues);

          sensitivitiesselect.push(value);
          setSelectedSensitivities(sensitivitiesselect);
        } else {
          let sensitivitiesremoved = sensitivitiesselect.filter(
            (e) => e !== value
          );
          let removeSelectedFilter = filterdValues.filter(
            (filter) =>
              !(filter.value === value && filter.filterType === action)
          );
          setSelectedSensitivities(sensitivitiesremoved);
          setAllSelectedFilter(removeSelectedFilter);
        }
        break;
      case "assetTypes":
        let assetTypesselect = [...selectedassetTypes];
        if (e?.target?.checked) {
          filterdValues.push({ filterType: action, value });
          setAllSelectedFilter(filterdValues);
          assetTypesselect.push(value);
          setSelectedassetTypes(assetTypesselect);
        } else {
          let assetTypesremoved = assetTypesselect.filter((e) => e !== value);
          let removeSelectedFilter = filterdValues.filter(
            (filter) =>
              !(filter.value === value && filter.filterType === action)
          );
          setSelectedassetTypes(assetTypesremoved);
          setAllSelectedFilter(removeSelectedFilter);
        }
        break;
      case "formats":
        let fileFormatsselect = [...selectedfileFormats];
        if (e?.target?.checked) {
          filterdValues.push({ filterType: action, value });
          setAllSelectedFilter(filterdValues);
          fileFormatsselect.push(value);
          setSelectedfileFormats(fileFormatsselect);
        } else {
          let fileFormatsremoved = fileFormatsselect.filter((e) => e !== value);
          let removeSelectedFilter = filterdValues.filter(
            (filter) =>
              !(filter.value === value && filter.filterType === action)
          );
          setSelectedfileFormats(fileFormatsremoved);
          setAllSelectedFilter(removeSelectedFilter);
        }
        break;
      case "outputPorts":
        let outputportselect = [...selectedOutputPorts];
        if (e?.target?.checked) {
          filterdValues.push({ filterType: action, value });
          setAllSelectedFilter(filterdValues);
          outputportselect.push(value);
          setSelectedoutputPorts(outputportselect);
        } else {
          let outputportremoved = outputportselect.filter((e) => e !== value);
          let removeSelectedFilter = filterdValues.filter(
            (filter) =>
              !(filter.value === value && filter.filterType === action)
          );
          setSelectedoutputPorts(outputportremoved);
          setAllSelectedFilter(removeSelectedFilter);
        }
        break;
      default:
      // code block
    }
  };


  useEffect(() => {
    if (!isObjectEmpty(params)) {
      setAdvancedFilter({
        // datasources: selecteddatasource,
        term: term,
        layers: selectedlayers,
        schemas: selectedschema,
        // domains: selecteddomain,
        orgModels: selectedorgmodel,
        businesses: selectedbusinesses,
        classifications: selectedclassifications,
        platforms: selectedplatforms,
        products: selectedproducts,
        // refreshFrequency: selectedrefreshfreq,
        sensitivities: selectedsensitivities,
        assetTypes: selectedassetTypes,
        formats: selectedfileFormats,
        certification: selectedcertification,
        owner: ownedataset,
        outputPorts: selectedOutputPorts

      });
    }

    if (prevterm) {
      setAdvancedFilter({
        // datasources: selecteddatasource,
        term: term,
        layers: selectedlayers,
        schemas: selectedschema,
        // domains: selecteddomain,
        orgModels: selectedorgmodel,
        businesses: selectedbusinesses,
        classifications: selectedclassifications,
        platforms: selectedplatforms,
        products: selectedproducts,
        // refreshFrequency: selectedrefreshfreq,
        sensitivities: selectedsensitivities,
        assetTypes: selectedassetTypes,
        formats: selectedfileFormats,
        certification: selectedcertification,
        owner: ownedataset,
        outputPorts: selectedOutputPorts
      });
    }
    setPageIndex(0);
  }, [
    // selecteddatasource,
    selectedlayers,
    selectedschema,
    // selecteddomain,
    selectedorgmodel,
    selectedbusinesses,
    selectedclassifications,
    selectedplatforms,
    selectedproducts,
    selectedrefreshfreq,
    selectedsensitivities,
    // selectedassetTypes,
    selectedfileFormats,
    selectedcertification,
    filterOwnedDataset,
    selectedOutputPorts

  ]);
  const searchcolumns = (e) => {
    const filtered = data.filter((o) =>
      SEARCHED_PROPS_VIEWALL.some((k) =>
        String(o[k]).toLowerCase().includes(e.target.value.toLowerCase())
      )
    );
    setFilteredData(filtered);
  };
  useEffect(() => {
    const fetchData = async () => {
      const { orgModels, products, businesses, platforms } = advancedFilters;
      if (!term) {
        if (
          !orgModels.length &&
          !products.length &&
          !businesses.length &&
          !platforms.length
        ) {
          return;
        }
      }

      if (!token && !error) {
        await getToken();
      }

      if (token) {
        if (!isObjectEmpty(params) && previouscategory !== params?.category) {
          await getdatasetFilters(token);
          setPreviousCategory(params.category)
        } else {
          if (prevterm !== term) {
            await getdatasetFilters(token);
          }
        }

        await getdatasets(token);
      } else if (error) {
        try {
          const rtoken = (await instance.acquireTokenRedirect(request))
            .accessToken;
          await getdatasets(rtoken);
        } catch (error) {
          console.log(error);
        }
      }
    };

    fetchData();
  }, [token, pageIndex, advancedFilters]);

  useEffect(() => {
    let updateAdvancedFilter = { ...advancedFilters };
    if (term) {
      clearAllFilter();
      setPageIndex(0);
    } else {
      if (params.category === "Portfolio") {
        updateAdvancedFilter.orgModels = [params.value];
        setSelectedOrgModel([params.value]);
      } else if (params.category === "orgModels") {
        updateAdvancedFilter.orgModels = [params.value];
        setSelectedOrgModel([params.value]);
      } else if (params.category === "Business Capability") {
        updateAdvancedFilter.businesses = [params.value];
        setSelectedBusinesses([params.value]);
      } else if (params.category === "layers") {
        updateAdvancedFilter.layers = [params.value];
        setSelectedLayers([params.value]);
      } else if (params.category === "schemas") {
        updateAdvancedFilter.schemas = [params.value];
        setSelectedSchema([params.value]);
      } else if (params.category === "classifications") {
        updateAdvancedFilter.classifications = [params.value];
        setSelectedClassifications([params.value]);
      } else if (params.category === "Platform") {
        updateAdvancedFilter.platforms = [params.value];
        setSelectedPlatforms([params.value]);
      } else if (params.category === "Product") {
        updateAdvancedFilter.products = [params.value];
        setSelectedProducts([params.value]);
      } else if (params.category === "sensitivities") {
        updateAdvancedFilter.sensitivities = [params.value];
        setSelectedSensitivities([params.value]);
      } else if (params.category === "assetTypes") {
        updateAdvancedFilter.assetTypes = [params.value];
        setSelectedassetTypes([params.value]);
      } else if (params.category === "formats") {
        updateAdvancedFilter.formats = [params.value];
        setSelectedfileFormats([params.value]);
      } else if (params.category === "refreshFrequency") {
        updateAdvancedFilter.refreshFrequency = params.value;
        setSelectedRefreshFreq(params.value);
      }
      if (selectedoutputportcontext) {
        updateAdvancedFilter.outputPorts = outport;
        setSelectedoutputPorts(outport);
      }

      // setAdvancedFilter(updateAdvancedFilter);
      if (params.category || selectedoutputportcontext) {
        let filterdValues = [...allSelectedFilter];
        filterdValues.push({
          filterType: params.category,
          value: params.value,
        });
        let outputportvalue = selectedoutputportcontext === "all" ? "" : selectedoutputportcontext;
        if (outputportvalue) {
          filterdValues.push({
            filterType: "outputPorts",
            value: outputportvalue,
          });
        }
        setAllSelectedFilter(filterdValues);
      }
    }
  }, [params, selectedoutputportcontext]);

  const getdatasetFilters = async (token) => {
    if (term || params.category) {

      setFilterLoading(true);

      let reqdata = "";
      let filters = { ...advancedFilters };
      if (!advancedFilters.certification) {
        delete filters["certification"];
        reqdata = JSON.stringify({
          criteria: criteria,
          pageIndex: pageIndex + 1,
          pageSize: 10,
          term: term,
          ...filters,
        });
      }
      if (!filterOwnedDataset) {
        delete filters["owner"];
        reqdata = JSON.stringify({
          criteria: criteria,
          pageIndex: pageIndex + 1,
          pageSize: 10,
          term: term,
          ...filters,
        });
      } else {
        reqdata = JSON.stringify({
          criteria: criteria,
          pageIndex: pageIndex + 1,
          pageSize: 10,
          term: term,
          ...filters,
        });
      }
      axios
        .post(`${DATABOOK_API}/search/filter`, reqdata, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then((res) => {
          // let updateddata = [];
          // setResponseFilterObj(res.data?.filters);
          if ((initialresponseFilterFlag && params.category?.length > 0)) {
            let filters = res.data;
            filters.classifications.push(null);
            filters.sensitivities.push(null);
            filters.formats.push(null);
            // filters.orgModels.push(null);
            filters.layers.push(null);
            // filters.platforms.push(null);
            filters.products.push(null);
            setSearchFilter(filters);
            setInitialresponseFilterFlag(false);
          }
          if (prevterm !== term) {

            let filters = res.data;
            filters.classifications.push(null);
            filters.sensitivities.push(null);
            filters.formats.push(null);
            // filters.orgModels.push(null);
            filters.layers.push(null);
            // filters.platforms.push(null);
            filters.products.push(null);
            setSearchFilter(filters)
            setPreviousTerm(term);
          }

          // setResponseCount(res.data?.count);
          // res.data.results?.forEach((item) => {
          //   if (item.description?.length > 130) {
          //     let alerted_desc = item.description.slice(0, 130);
          //     updateddata.push({
          //       ...item,
          //       alerted_desc,
          //       show: true,
          //       descCount: item.description.length,
          //     });
          //   } else {
          //     updateddata.push({
          //       ...item,
          //       alerted_desc: "",
          //       show: false,
          //       descCount: item.description?.length,
          //     });
          //   }
          // });

          // setData(updateddata);
          // setFilteredData(updateddata);
          setFilterLoading(false);
        }).catch((error) => {
          if (error.response.status === 401) {
            console.log(error)
            const rtoken = (instance.acquireTokenRedirect(request))
              .accessToken;
            getdatasetFilters(rtoken);

          }
          setFilterLoading(false);
        });
    } else {
      clearAllFilter();
      setSearchFilter([])
    }
  };
  const getdatasets = async (token) => {
    if (term || params.category) {
      setIsFetching(true);
      let reqdata = "";
      let filters = { ...advancedFilters };
      if (!advancedFilters.certification) {
        delete filters["certification"];
        reqdata = JSON.stringify({
          criteria: criteria,
          pageIndex: pageIndex + 1,
          pageSize: 10,
          term: term,
          ...filters,
        });
      }
      if (!filterOwnedDataset) {
        delete filters["owner"];
        reqdata = JSON.stringify({
          criteria: criteria,
          pageIndex: pageIndex + 1,
          pageSize: 10,
          term: term,
          ...filters,
        });
      } else {
        reqdata = JSON.stringify({
          criteria: criteria,
          pageIndex: pageIndex + 1,
          pageSize: 10,
          term: term,
          ...filters,
        });
      }
      //
      axios
        .post(`${DATABOOK_API}/search`, reqdata, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then((res) => {
          let updateddata = [];
          // setResponseFilterObj(res.data?.filters);
          // if ((initialresponseFilterFlag && params.category?.length > 0)) {
          //   setSearchFilter(res.data?.filters);
          //   setInitialresponseFilterFlag(false);
          // }
          // if (prevterm !== term) {
          //   setSearchFilter(res.data?.filters)
          //   setPreviousTerm(term);
          // }

          setResponseCount(res.data?.count);
          res.data.results?.forEach((item) => {
            if (item.description?.length > 130) {
              let alerted_desc = item.description.slice(0, 130);
              updateddata.push({
                ...item,
                alerted_desc,
                show: true,
                descCount: item.description.length,
              });
            } else {
              updateddata.push({
                ...item,
                alerted_desc: "",
                show: false,
                descCount: item.description?.length,
              });
            }
          });

          setData(updateddata);
          setFilteredData(updateddata);
          setIsFetching(false);
        }).catch((error) => {
          setIsFetching(false);
          if (error.response.status === 401) {
            console.log(error)
            const rtoken = (instance.acquireTokenRedirect(request))
              .accessToken;
            getdatasets(rtoken);

          }
        });
    } else {
      clearAllFilter();
      setSearchFilter([])
    }
  };

  useEffect(() => {
    {
      filters?.businesses &&
        setBusinesses(filters?.businesses);
    }
    {
      filters?.layers && setLayers(filters?.layers);
    }
    {
      filters?.orgModels &&
        setOrgModel(filters?.orgModels);
    }
    {
      filters?.datasetSchemas &&
        setSchema(filters?.datasetSchemas);
    }
    {
      filters?.classifications &&
        setClassifications(filters?.classifications);
    }
    {
      filters?.platforms &&
        setPlatforms(filters?.platforms);
    }
    {
      filters?.products &&
        setProducts(filters?.products);
    }
    {
      filters?.refreshFrequencies &&
        setRefreshFreq(filters?.refreshFrequencies);
    }
    {
      filters?.sensitivities &&
        setSensitivities(filters?.sensitivities);
    }
    {
      filters?.assetTypes &&
        setAssetTypes(filters?.assetTypes);
    }
    {
      filters?.formats &&
        setFileFormats(filters?.formats);
    }
    {
      filters?.certifications &&
        setCertification(filters?.certifications);
    }
    {
      filters?.outputPorts &&
        setoutputPorts(filters?.outputPorts);
    }
  }, [filters]);

  const certifiedToggle = (flag) => {
    if (flag) {
    } else {
    }
    setCertifiedToggle(flag);
    setSelectedCertification(flag);
  };
  const filterOwnedDatasetfunc = (ownedatasetFlag) => {
    let username = account.username;

    if (ownedatasetFlag) {
      setOwneDataset(username.toLocaleLowerCase())
    } else {
      setOwneDataset("")
    }

    setFilterOwnedDataset(ownedatasetFlag);
  };
  const clearAllFilter = () => {
    if (params.category === "Portfolio" && term.length === 0) {
      setAllSelectedFilter([{ filterType: params.category, value: params.value }]);
      setSelectedOrgModel([params.value]);
      setSelectedBusinesses([]);
      setSelectedPlatforms([]);
      setSelectedProducts([]);
    } else if (params.category === "Business Capability" && term.length === 0) {
      setAllSelectedFilter([{ filterType: params.category, value: params.value }]);
      setSelectedBusinesses([params.value]);
      setSelectedOrgModel([]);
      setSelectedPlatforms([]);
      setSelectedProducts([]);
    } else if (params.category === "Platform" && term.length === 0) {
      setAllSelectedFilter([{ filterType: params.category, value: params.value }]);
      setSelectedPlatforms([params.value]);
      setSelectedOrgModel([]);
      setSelectedBusinesses([]);
      setSelectedProducts([]);
    } else if (params.category === "Product" && term.length === 0) {
      setAllSelectedFilter([{ filterType: params.category, value: params.value }]);
      setSelectedProducts([params.value]);
      setSelectedOrgModel([]);
      setSelectedBusinesses([]);
      setSelectedPlatforms([]);
    } else {
      setAllSelectedFilter([]);
    }
    if ((term.length > 0 && !params.category) || (!term && !params.category)) {
      setSelectedProducts([]);
      setSelectedOrgModel([]);
      setSelectedBusinesses([]);
      setSelectedPlatforms([]);
    }
    setSelectedDataSources([]);
    setSelectedDataDomain([]);
    setSelectedLayers([]);
    setSelectedSchema([]);
    setSelectedClassifications([]);
    setSelectedRefreshFreq([]);
    setSelectedSensitivities([]);
    setSelectedassetTypes([]);
    setSelectedfileFormats([]);
    setSelectedCertification(false);
    setCertifiedToggle(false);
    setFilterOwnedDataset(false);
    if (
      (term === null || term?.length == 0 || term === "") &&
      !params.category
    ) {
      // viewallsummary(token);
    } else {
      // searchDatasetByFilter("CLEARALL");
    }
  };

  const updateFilterData = (fqn, likesCount) => {
    var datasetData = [...filteredata];
    let record = datasetData[datasetData.findIndex((el) => el.fqn === fqn)];
    record.likesCount = likesCount;
    record.likeColor = true;
    datasetData[datasetData.findIndex((el) => el.fqn === fqn)] = record;
    setFilteredData(datasetData);
  };

  const viewallsummary = (token) => {
    setIsFetching(true);

    axios
      .get(`${DATABOOK_API}/datasets/summary?page_no=0&page_size=3000`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        let updateddata = [];
        response.data.datasetSummaryList?.forEach((item) => {
          if (item.description?.length > 130) {
            let alerted_desc = item.description.slice(0, 130);
            updateddata.push({
              ...item,
              alerted_desc,
              show: true,
              descCount: item.description.length,
            });
          } else {
            updateddata.push({
              ...item,
              alerted_desc: "",
              show: false,
              descCount: item.description?.length,
            });
          }
        });
        setData(updateddata);
        setFilteredData(updateddata);
        setIsFetching(false);
      })
      .catch((error) => {
        setIsFetching(false);
      });
  };
  const enableReadMore = (fqnvalue, flag) => {
    const newProjects = filteredata.map((item) =>
      item.fqn === fqnvalue ? { ...item, show: flag } : item
    );
    setData(newProjects === undefined ? [] : newProjects);
    setFilteredData(newProjects === undefined ? [] : newProjects);
  };

  ;

  return (
    <div style={{ marginTop: "4.25rem", border: "0px solid red" }}>
      <div style={{ padding: "25px 25px 14px 25px" }}>
        <h4>
          Showing search results for:{" "}

          <strong>
            {searchterm ? searchterm : params.value}
            {/* {searchKeyword.term ? searchKeyword.term : params.value} */}
          </strong>
        </h4>
      </div>

      {/* <div style={{ border: "1px solid lightgrey", padding: "10px", margin:"10px 25px",borderRadius:"5px",  }}>
        <span>Quick Filters :</span>
        {items.map((item, index) => (
          <span key={index} style={{ backgroundColor: item.color, padding: "4px 10px", margin: "2px 5px", borderRadius:"20px", fontSize:"12px" }}>
            {item.text}
          </span>
        ))} 
    </div> */}

      <Col
        className="main_container"
        style={{ marginTop: "0", paddingTop: "0" }}
      >
        <AdvancedFilterComponent
          // responseFilterObj={responseFilterObj}
          // setResponseCount={setResponseCount}
          setFilteredData={setFilteredData}
          searchfilter={data}
          filteredata={filteredata}
          setData={setData}
          filterloading={filterloading}
          // setIsFetching={setIsFetching}
          // setAdvancedFilter={setAdvancedFilter}
          category={params.category}
          categoryValue={params.value}
          filterOwnedDataset={filterOwnedDataset}
          setFilterOwnedDataset={setFilterOwnedDataset}
          certifiedtoggle={certifiedtoggle}
          setCertifiedToggle={setCertifiedToggle}
          // viewallsummary={viewallsummary}
          searchcolumns={searchcolumns}
          filters={filters}
          handleAddAndRemoveFilter={handleAddAndRemoveFilter}
          allSelectedFilter={allSelectedFilter}
          clearAllFilter={clearAllFilter}
          certifiedToggle={certifiedToggle}
          filterOwnedDatasetfunc={filterOwnedDatasetfunc}
          datasource={datasource}
          layers={layers}
          schemas={schemas}
          domain={domain}
          businesses={businesses}
          orgmodel={orgmodel}
          classifications={classifications}
          platforms={platforms}
          products={products}
          refreshFreq={refreshFreq}
          sensitivities={sensitivities}
          assetTypes={assetTypes}
          fileFormats={fileFormats}
          certification={certification}
          outputPorts={outputPorts}
          selecteddatasource={selecteddatasource}
          selecteddomain={selecteddomain}
          selectedlayers={selectedlayers}
          selectedschema={selectedschema}
          selectedorgmodel={selectedorgmodel}
          selectedbusinesses={selectedbusinesses}
          selectedclassifications={selectedclassifications}
          selectedplatforms={selectedplatforms}
          selectedproducts={selectedproducts}
          selectedrefreshfreq={selectedrefreshfreq}
          selectedsensitivities={selectedsensitivities}
          selectedassetTypes={selectedassetTypes}
          selectedfileFormats={selectedfileFormats}
          selectedcertification={selectedcertification}
          selectedOutputPorts={selectedOutputPorts}
          selectedoutputportcontext={selectedoutputportcontext}
        // outputPorts={outputPorts}
        />
        {isFetching ? (
          <Col className="main_content">
            <div className="mt-5">
              <Spinner />
            </div>
          </Col>
        ) : (
          <ReusableDatasetsContent
            responseCount={responseCount}
            setPageIndex={setPageIndex}
            pageIndex={pageIndex}
            data={data}
            filteredata={filteredata}
            searchcolumns={searchcolumns}
            updateFilterData={updateFilterData}
            enableReadMore={enableReadMore}
          />
        )}
      </Col>
    </div>
  );
};

export default DomainTableData;
